<div class="delivery-session-feedback-view-part">
	<grid-content [setup]="setup()" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="sessionFeedbacks()"></grid-content>
</div>